import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface XeroConnectRequiredDialogProps {
  open: boolean;
  onClose: () => void;
  /**
   * The user has a connection, but to a Xero organisation this site is not
   * pinned to. Connecting again is still the fix; connecting to the same
   * organisation is not obvious from the generic copy.
   */
  wrongOrg?: boolean;
}

/**
 * Shown when a push is attempted without a usable Xero connection. Xero is
 * per-user, so the fix is always "connect yourself under Configuration → Xero",
 * never "ask an admin".
 */
const XeroConnectRequiredDialog: React.FC<XeroConnectRequiredDialogProps> = ({
  open,
  onClose,
  wrongOrg = false,
}) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="xero-connect-required-title"
      PaperProps={{ sx: { width: 444, maxWidth: "100%" } }}
    >
      <DialogTitle id="xero-connect-required-title" sx={{ px: 3, py: 2 }}>
        {wrongOrg ? "Wrong Xero organisation" : "Connect to Xero first"}
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3, py: 2.5 }}>
        <DialogContentText>
          {wrongOrg
            ? "Your Xero login is connected to a different Xero organisation than the one this site pushes to, so nothing can go up. Change your Xero connection under Configuration → Xero, then come back and push."
            : "Pushing to Xero uses your own Xero login. Connect under Configuration → Xero first, then come back and push. It takes about a minute and only affects you."}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 1 }}>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onClose();
            navigate("/xero");
          }}
          variant="contained"
          color="primary"
          autoFocus
        >
          Go to Xero settings
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default XeroConnectRequiredDialog;
